import styled from "styled-components";
import { InviteIcon, TermBg } from "@assets";
import { Button as AntButton } from "antd";

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

export const Heading = styled.div`
	margin-top: 22px;
	border-radius: 10px;
	width: 93%;
	height: 136px;
	background-color: #e1f0ff;
`;

export const ChainIconContainer = styled.div``;

export const ChainIcon = styled(InviteIcon)`
	width: 42px;
	height: 42px;
`;

export const InviteLinkTitle = styled.p`
	color: #000000;
	font-weight: 600;
	font-size: 16px;
`;

export const CreateLinkButton = styled(AntButton)`
	color: #ffffff !important;
	font-weight: 500;
	font-size: 14px;
	width: 314px;
	background-color: #3198da !important;
	&:hover {
		background-color: #3198da !important;
	  color: #ffffff !important;
	}
  @media screen and (max-width: 370px){
    width: 260px; 
  }
`;

export const TermsAndConditionsContainer = styled.div`
	min-height: calc(100vh - 400px - 70px);
	border-radius: 10px;
	width: 93%;
	background-color: #e1f0ff;
  padding: 10px 0;
`;

export const InviteLinkTerms = styled.span`
	margin: 0px;
	padding: 0px;
	color: #000000;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
`;

export const CopyTitle = styled.p`
	margin-bottom: 10px;
	color: #0161BF;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

export const CopyLink = styled.a`
	display: block;
	color: #6D7F8A;
	text-align: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16.94px; /* 171.429% */
`;

export const InviteSubTitle = styled.p`
	color: #585858;
	font-weight: 500;
	font-size: 12px;
`;

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const ChainTextWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	width: 260px;
	margin: 0 auto;
	margin-top: 14px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin: 15px 0;
`;

export const TopWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const TitleWrapper = styled.div`
  margin: 10px 0 5px;
	background-image: url(${TermBg});
	background-repeat: no-repeat;
	background-position: center; /* Center the background image horizontally and vertically */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 315px;
`;

export const Title = styled.p`
	color: #000000;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 50px;
`;